import React, { Fragment } from "react";
import {
  Button as MuiButton,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PropTypes from "prop-types";
import useStyles from "src/atoms/Button/style.js";

const Button = ({
  color = "primary",
  size = "medium",
  action,
  children,
  type,
  disabled,
  loading = false,
  variant,
  isSubmit,
}) => {
  const classes = useStyles();

  const handleClass = (val) => {
    const result = Object.keys(classes).find((item) => {
      return item === val;
    });
    return result ?? "primary";
  };

  const handleIcon = (type) => {
    const iconSize = size === "small" ? 18 : size === "medium" && 22;
    switch (type) {
      case "addAction":
        return (
          <AddCircleIcon
            style={{ fontSize: iconSize }}
            className={classes.icon}
          />
        );
      case "viewAction":
        return (
          <VisibilityIcon
            style={{ fontSize: iconSize }}
            className={classes.icon}
          />
        );
      default:
        return null;
    }
  };

  return (
    <MuiButton
      className={[
        classes[handleClass(color)],
        classes[handleClass(type)],
        classes[handleClass(size)],
        classes[handleClass(variant)],
        loading &&
          (color === "secondary" ? classes.darkLoader : classes.lightLoader),
      ].join(" ")}
      onClick={action}
      variant={variant}
      disabled={loading || disabled}
      type={isSubmit && "submit"}
    >
      <Fragment>
        {loading ? (
          <CircularProgress
            className={
              size === "medium" ? classes.mediumLoader : classes.smallLoader
            }
          />
        ) : (
          <Fragment>
            {handleIcon(type)}
            <Typography variant="button">{children}</Typography>
          </Fragment>
        )}
      </Fragment>
    </MuiButton>
  );
};

Button.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "primaryOutlined",
    "secondary",
    "transparent",
  ]),
  size: PropTypes.oneOf(["xs", "small", "medium"]),
  action: PropTypes.func,
  children: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["addAction", "callToAction", "viewAction"]),
};

export { Button };
